import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=88064a4a&scoped=true"
import script from "./CountryItem.vue?vue&type=script&lang=js"
export * from "./CountryItem.vue?vue&type=script&lang=js"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=88064a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88064a4a",
  null
  
)

export default component.exports